export function carousel3d($) {
	$('.carousel3d').each(function(n, el) {
		var $carousel = $(el);
		var num = 3; // slides

		// first slide active
		$('.slide:first-of-type', el).addClass('active');

		$('.next', el).on('click', function(event) {
			event.preventDefault();
			var pos = $carousel.attr('data-position');
			var newpos = (pos+1) % num;
			$carousel.attr('data-position', newpos);
			$('.slide', $carousel).removeClass('active');
			$('.slide[data-index="' + newpos + '"]', $carousel).addClass('active');
		});

		$('.prev', el).on('click', function(event) {
			event.preventDefault();
			var pos = $carousel.attr('data-position');
			var newpos = ((pos-1) + num) % num;
			$carousel.attr('data-position', newpos);
			$('.slide', $carousel).removeClass('active');
			$('.slide[data-index="' + newpos + '"]', $carousel).addClass('active');
		});

		$('.slide-image', el).on('click', function(event) {
			event.preventDefault();
			var $slide  = $(this).parent();
			var index = $slide.attr('data-index');
			$carousel.attr('data-position', index);
			$('.slide', $carousel).removeClass('active');
			$('.slide[data-index="' + index + '"]', $carousel).addClass('active');
		})
	});
}